import { Record } from 'immutable';

const {
    SESSION_TOKEN_REQUEST,
    SESSION_TOKEN_SUCCESS,
    SESSION_TOKEN_FAILURE,

    DELETE_TOKEN_REQUEST,
    DELETE_TOKEN_SUCCESS,

    LOGOUT_REQUEST,
    LOGOUT_SUCCESS,
    LOGOUT_FAILURE,

    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,

    SIGNUP_REQUEST,
    SIGNUP_SUCCESS,
    SIGNUP_FAILURE,

    SIGNUP_SCHOOL_SEARCH_REQUEST,
    SIGNUP_SCHOOL_SEARCH_SUCCESS,
    SIGNUP_SCHOOL_SEARCH_FAILURE
} = require('./authActions').constants;

const InitialState = Record({
    disabled: false,
    error: null,
    isFetching: false,
    isLoggedIn: false,
    selectedSchool: null
});

const initialState = new InitialState();

/**
 * ## authReducer function
 * @param {Object} state - initialState
 * @param {Object} action - type and payload
 */
export default function authReducer(state = initialState, { payload, type }) {
    if (!(state instanceof InitialState)) return initialState.mergeDeep(state);

    switch (type) {
    case SESSION_TOKEN_REQUEST:
    case SIGNUP_REQUEST:
    case LOGOUT_REQUEST:
    case LOGIN_REQUEST:
    case SIGNUP_SCHOOL_SEARCH_REQUEST:
        return state.set('isFetching', true)
                .set('error', null);

    case SESSION_TOKEN_SUCCESS:
    case SIGNUP_SUCCESS:
    case LOGIN_SUCCESS:
        return state.set('isFetching', false)
            .set('isLoggedIn', true);

    case LOGOUT_SUCCESS:
        return state.set('isFetching', false)
            .set('isLoggedIn', false);

    case SESSION_TOKEN_FAILURE:
    case DELETE_TOKEN_SUCCESS:
        return state.set('isFetching', false)
            .set('isLoggedIn', false);

    case SIGNUP_SCHOOL_SEARCH_SUCCESS:
        return state.set('isFetching', false)
            .set('selectedSchool', payload.data[0]);

    case SIGNUP_FAILURE:
    case LOGOUT_FAILURE:
    case LOGIN_FAILURE:
    case SIGNUP_SCHOOL_SEARCH_FAILURE:
        return state.set('isFetching', false)
                .set('error', payload);

    case DELETE_TOKEN_REQUEST:
        /**
         * no state change, just an ability to track action requests...
         */
        return state;

    default:
        return state;

    }
}



/** WEBPACK FOOTER **
 ** ./src/core/auth/authReducer.js
 **/